import { Container, Title, Text, Stack, Group, Box } from '@mantine/core';
import { IconCheck } from '@tabler/icons-react';
import { useLanguage } from '@/context/LanguageContext';
import { useSEO } from '@/lib/useSEO';

export default function AboutUsPage() {
  const { t } = useLanguage();

  // SEO for About Us page
  useSEO({
    title: t('seo.about.title') || 'About Us - Luxelo',
    description: t('seo.about.description') || 'Learn about Luxelo - our mission, values, and commitment to providing premium LED lighting solutions.',
    type: 'website',
  });

  return (
    <Container size="xl" py="xl">
      <Stack gap="xl">
        <Box>
          <Title order={1} mb="md">{t('aboutUs.title')}</Title>
          <Text size="lg" c="dimmed" mb="xl">
            {t('aboutUs.subtitle')}
          </Text>
        </Box>

        <Box>
          <Title order={2} mb="md">{t('aboutUs.mission.title')}</Title>
          <Text size="md" mb="md">
            {t('aboutUs.mission.description')}
          </Text>
        </Box>

        <Box>
          <Title order={2} mb="md">{t('aboutUs.values.title')}</Title>
          <Stack gap="md">
            <Group gap="md" align="flex-start">
              <IconCheck size={24} style={{ color: '#228be6', marginTop: '4px', flexShrink: 0 }} />
              <Box>
                <Text fw={600} mb="xs">{t('aboutUs.values.quality.title')}</Text>
                <Text size="sm" c="dimmed">{t('aboutUs.values.quality.description')}</Text>
              </Box>
            </Group>
            <Group gap="md" align="flex-start">
              <IconCheck size={24} style={{ color: '#228be6', marginTop: '4px', flexShrink: 0 }} />
              <Box>
                <Text fw={600} mb="xs">{t('aboutUs.values.innovation.title')}</Text>
                <Text size="sm" c="dimmed">{t('aboutUs.values.innovation.description')}</Text>
              </Box>
            </Group>
            <Group gap="md" align="flex-start">
              <IconCheck size={24} style={{ color: '#228be6', marginTop: '4px', flexShrink: 0 }} />
              <Box>
                <Text fw={600} mb="xs">{t('aboutUs.values.customer.title')}</Text>
                <Text size="sm" c="dimmed">{t('aboutUs.values.customer.description')}</Text>
              </Box>
            </Group>
            <Group gap="md" align="flex-start">
              <IconCheck size={24} style={{ color: '#228be6', marginTop: '4px', flexShrink: 0 }} />
              <Box>
                <Text fw={600} mb="xs">{t('aboutUs.values.sustainability.title')}</Text>
                <Text size="sm" c="dimmed">{t('aboutUs.values.sustainability.description')}</Text>
              </Box>
            </Group>
          </Stack>
        </Box>

        <Box>
          <Title order={2} mb="md">{t('aboutUs.story.title')}</Title>
          <Text size="md" mb="md">
            {t('aboutUs.story.description')}
          </Text>
        </Box>

        <Box>
          <Title order={2} mb="md">{t('aboutUs.team.title')}</Title>
          <Text size="md">
            {t('aboutUs.team.description')}
          </Text>
        </Box>
      </Stack>
    </Container>
  );
}

